import config from '@packages/config';
import DOMPurify from '@packages/config/utils/dompurify';
import { ComponentTypes } from '../../../../interfaces';
import { registerComponents } from '../../ComponentRecognizer/componentRegistry';
import type { FooterBlockTextType } from '../types';

const isDarkStyle = config.styleVariant === 'dark';

const styleClasses = [
  '[&_h6,&_p:last-of-type]:font-stretch-normal [&_h6,&_p:last-of-type]:not-italic [&_h6,&_p:last-of-type]:tracking-normal [&_h6,&_p:last-of-type]:font-normal [&_h6,&_p:last-of-type]:text-size-body3',
  '[&_h1,&_h2,&_h3,&_h4,&_h5,&_h6,&_ul,&_ol,&_li,&_p]:m-0 [&_h1,&_h2,&_h3,&_h4,&_h5,&_h6,&_ul,&_ol,&_li,&_p]:p-0',
  '[&_p]:m-0 [&_p]:p-0 [&_p]:pb-2',
  '[&_p_img]:m-0 [&_p_img]:ml-0.5 [&_p_img]:inline-flex [&_p_img]:shrink-0 [&_p_img]:content-center [&_p_img]:p-0 [&_p_img]:align-baseline',
  '[&_p:last-of-type]:-mt-2 [&_p:last-of-type]:pt-0',
  '[&_ul]:list-none [&_ul]:pl-0 [&_ul,&_ol]:m-0',
  '[&_ul_li]:mb-1',
  '[&_ul_li.type-1]:ml-0 [&_ul_li.type-1]:flex [&_ul_li.type-1]:leading-1 [&_ul_li.type-1]:before:leading-1 [&_ul_li.type-1]:before:flex [&_ul_li.type-1]:before:h-[0.8rem] [&_ul_li.type-1]:before:w-2 [&_ul_li.type-1]:before:shrink-0 [&_ul_li.type-1]:before:basis-2 [&_ul_li.type-1]:before:lg:h-[0.94rem] [&_ul_li.type-1]:before:lg:w-2.5',
  isDarkStyle ? '[&_ul_li.type-1]:before:content-["→"]' : '[&_ul_li.type-1]:before:content-["✓"]',
  isDarkStyle ? '[&_ul_li.type-1]:before:mr-1.5' : null,
  isDarkStyle ? '[&_ul_li.type-1]:before:text-size-h3' : null,
  !isDarkStyle ? '[&_ul_li.type-1]:before:font-bold' : null,
  '[&_ul_li.type-3]:pl-2 [&_ul_li.type-3]:lg:pl-2.5',
];

export const BlockText = ({ data }: { data: FooterBlockTextType }) => (
  <div
    className={styleClasses.join(' ').trim()}
    key={`block-text-${data.id}`}
    // eslint-disable-next-line react/no-danger
    dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(data.field_html_editor) }}
  />
);

// Needed to run this component in Storybook and Jest tests. Register the component in a global componentRegistry object
registerComponents({ [ComponentTypes.BlockText]: BlockText });
